import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

type ButtonProps = {
  variant?: 'primary' | 'secondary' | 'transparent';
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
} & ComponentProps<'button'>;

const Button = ({
  variant = 'primary',

  fullWidth = false,
  size = 'lg',
  className,
  ...props
}: ButtonProps) => {
  const variantStyle = (() => {
    switch (variant) {
      case 'primary':
        return 'bg-ph-primary-violet-gradient hover:bg-none hover:bg-ph-primary-violet text-white';
      case 'secondary':
        return 'bg-ph-gray-cod border border-ph-gray-silver text-ph-gray-silver hover:text-ph-secondary-portage  hover:border-ph-secondary-portage active:text-white active:border-white';
      case 'transparent':
        return 'text-ph-gray-silver hover:text-ph-secondary-portage  active:text-white bg-transparent';
    }
  })();

  const sizeStyle = (() => {
    switch (size) {
      case 'lg':
        return 'px-5 py-3 h-12';
      case 'md':
        return 'px-5 py-2';
      default:
        return 'p-5 py-3';
    }
  })();

  return (
    <button
      className={twMerge(
        'cursor-pointer rounded-lg text-sm font-normal leading-5 tracking-wide',
        !props.disabled ? variantStyle : 'border-none bg-ph-gray-baltic text-ph-gray-jumbo hover:cursor-not-allowed',
        fullWidth && 'w-full',
        sizeStyle,
        className,
      )}
      {...props}
    >
      {props.children}
    </button>
  );
};

export default Button;
